import { Case } from '../beans/Case';
import { CaseSearch } from '../beans/CaseSearch';
import { Component, OnInit, ViewChild, Host, ViewContainerRef, HostListener, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { Lawyer } from '../beans/Lawyer';
import { Nomenclature } from '../beans/Nomenclature';
import { Person } from '../beans/Person';
import { FrxBaseBean } from '../beans/frxbasebean';
import { Payment } from '../beans/payment';
import { BlockUiService } from '../services/blockui.service';
import { CaseService } from '../services/case.service';
import { NomenclatureService } from '../services/nomenclature.service';
import { ReportService } from '../services/report.service';
import { AuthService } from '../services/auth.service';
import { DatePipe } from '@angular/common';
import { CompleterService, CompleterData } from 'ng2-completer';
import * as FileSaver from 'file-saver';

@Component({
	selector: 'app-cases',
	templateUrl: './cases.component.html',
	styleUrls: ['./cases.component.scss']
})

export class CasesComponent implements OnInit {

	@ViewChild('editCase') editCaseModal;

	@ViewChild('caseNumberWrapper') caseNumberWrapper!: ElementRef;

	@ViewChild('damageNumberWrapper') damageNumberWrapper!: ElementRef;

	page = {
		number: 0,
		size: 10,
		totalElements: 0,
		totalPages: 0
	};

	selectedSerchCase = new CaseSearch();
	caseList: Array<Case>;
	claimant: Person;
	defendant: Person;

	lawyers: any[] = [];
	selectedLawyerId: number = null;

	traumaTypes: any[] = [];
	selectedTraumaTypeId: number = null;


	public caseColumns = [
		{ title: 'Гр. дело номер', name: 'caseNumber' },
		{ title: 'Щета номер', name: 'damageNumber' },
		{
			title: 'Изпълнително дело', name: 'izpulnitelnoDelo',
			dataType: 'object', complexDataType: { object: true, displayValue: 'number' }
		},
		{
			title: 'Наказателно Дело', name: 'nakazatelnoDelo',
			dataType: 'object', complexDataType: { object: true, displayValue: 'number' }
		},
		{
			title: 'Прокурорска преписка', name: 'nakazatelnoDelo',
			dataType: 'object', complexDataType: { object: true, displayValue: 'prokusrorskaPrepiskaNomer' }
		},
		{ title: 'ЗМ-МВР', name: 'nakazatelnoDelo', dataType: 'object', complexDataType: { object: true, displayValue: 'zmMvrNomer' } },

		{
			title: 'Тип Травма', name: 'traumaType',
			dataType: 'object', complexDataType: { object: true, displayValue: 'name' }
		},

		{ title: 'Цена на иска', name: 'cost', dataType: 'currency' },
	];

	currentUserId: number;

	constructor(
		private vcRef: ViewContainerRef, private blockUi: BlockUiService, private datePipe: DatePipe, private caseService: CaseService,
		private reportService: ReportService,
		private nomenclatureService: NomenclatureService, private authService: AuthService, ) {
		this.currentUserId = this.authService.getUserId();
	}

	ngOnInit() {
		this.caseList = new Array<Case>();
		this.loadTraumaTypes();
		this.loadLawyers();

		// ⬇⬇⬇ ПЪРВО ЗАРЕЖДАНЕ
		//this.search(0, this.page.size);

		this.caseService.caseSaved$.subscribe(() => {
			this.search(this.page.number, this.page.size);
		});
	}

	onKeydown(event) {
		if (event.key === 'Enter') {
			this.search();
		}
	}

	@HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
		if (event.key === 'Enter') {
			this.search();
		}
	}

	private loadTraumaTypes() {
		this.traumaTypes = new Array<Nomenclature>();
		this.nomenclatureService.getTraumaTypes().subscribe(data => {
			this.traumaTypes = data;
		});
	}

	private loadLawyers() {
		this.lawyers = new Array<Lawyer>();
		this.nomenclatureService.getLawyers().subscribe(data => {
			this.lawyers = data;
		});
	}

	search(page: number = 0, size: number = this.page.size, showBlockUi: boolean = true) {

		if (showBlockUi) {
			this.blockUi.start(this.vcRef);
			this.createSearch();
		}

		this.caseService.searchCases(this.selectedSerchCase, page, size).subscribe(
			result => {

				// 1️⃣ РЕЗУЛТАТИ
				this.caseList = result.content;

				for (let i = 0; i < this.caseList.length; i++) {
					if (result.content[i].date != null) {
						this.caseList[i].date = this.datePipe.transform(
							new Date(result.content[i].date),
							'dd.MM.yyyy'
						);
					}
					if (result.content[i].claimDate != null) {
						this.caseList[i].claimDate = this.datePipe.transform(
							new Date(result.content[i].claimDate),
							'dd.MM.yyyy'
						);
					}
				}

				// 2️⃣ ⭐ ЕТО ТОВА Е КЛЮЧОВОТО ⭐
				this.page = {
					number: result.number,
					size: result.size,
					totalElements: result.totalElements,
					totalPages: result.totalPages
				};

				console.log('PAGE UI:', this.page);

				this.blockUi.stop();
			},
			error => {
				this.blockUi.stop();
			}
		);
	}

	createSearch() {
		if (this.claimant && this.claimant.name) {
			this.selectedSerchCase.claimant = this.claimant.name;
		} else {
			this.selectedSerchCase.claimant = '';
		}
		if (this.defendant && this.defendant.name) {
			this.selectedSerchCase.defendant = this.defendant.name;
		} else {
			this.selectedSerchCase.defendant = '';
		}

		this.selectedSerchCase.responsible = this.selectedLawyerId; // <<< ТУК ГО ПОДАВАШ
		this.selectedSerchCase.traumaTypeId = this.selectedTraumaTypeId; // <<< ТУК ГО ПОДАВАШ
	}

	clearClaimant() {
		this.claimant = null;
	}
	clearDefendant() {
		this.defendant = null;
	}

	public extractExcel() {
		this.blockUi.start(this.vcRef);
		this.createSearch();

		this.reportService.executeXLSReport(this.selectedSerchCase).subscribe({
			next: response => {
				this.blockUi.stop();

				const contentDisposition = response.headers.get('Content-Disposition');
				let filename = 'report.xlsx';

				// Извличане на името от хедъра
				if (contentDisposition) {
					const match = contentDisposition.match(/filename="?([^"]+)"?/);
					if (match && match[1]) {
						filename = match[1];
					}
				}

				const blob = new Blob([response.body], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				FileSaver.saveAs(blob, filename);
			},
			error: err => {
				console.log(err);
				this.blockUi.stop();
			}
		});
	}


	public extractExcelTrauma() {
		this.blockUi.start(this.vcRef);
		this.createSearch();

		this.reportService.executeXLSReportTrauma(this.selectedSerchCase).subscribe({
			next: response => {
				this.blockUi.stop();

				const contentDisposition = response.headers.get('Content-Disposition');
				let filename = 'report-trauma.xlsx';

				// Извличане на името от хедъра
				if (contentDisposition) {
					const match = contentDisposition.match(/filename="?([^"]+)"?/);
					if (match && match[1]) {
						filename = match[1];
					}
				}

				const blob = new Blob([response.body], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				FileSaver.saveAs(blob, filename);
			},
			error: err => {
				console.log(err);
				this.blockUi.stop();
			}
		});
	}

	formatDate(dateToFormat): Date {
		if (dateToFormat) {
			if (typeof dateToFormat === 'string' || dateToFormat instanceof String) {
				let dateParts: string[] = dateToFormat.split('.');
				//month is 0-based, that's why we need dataParts[1] - 1
				return new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]), 12, 0, 0, 0);
			}
			return dateToFormat;
		}
		return;
	}

	deleteCase(event) {
		if (confirm('Are you sure?')) {
			this.blockUi.start(this.vcRef);
			this.caseService.deleteCase(event.id).subscribe(
				data => {
					alert('Successfully deleted!');
					this.search();
					this.blockUi.stop();
				},
				error => {
					alert('Error: ' + error.message);
					this.blockUi.stop();
				});
		}
		return;
	}

	compareFrxObjects(o1: FrxBaseBean, o2: FrxBaseBean) {
		if (o1 && o2) {
			return o1.id === o2.id;
		}
	}

	/** autocomplete caseNumber  */
	caseNumberSuggestions: string[] = [];

	onCaseNumberChange(value: string): void {
		this.selectedSerchCase.caseNumber = value;

		if (!value || value.length < 2) {
			this.caseNumberSuggestions = [];
			return;
		}

		this.caseService.getCaseNumberSuggestions(value)
			.subscribe(list => this.caseNumberSuggestions = list);
	}

	selectCaseNumber(value: string): void {
		this.selectedSerchCase.caseNumber = value;
		this.caseNumberSuggestions = [];
	}

	/** autocomplete damageNumber  */
	damageNumberSuggestions: string[] = [];

	onDamageNumberChange(value: string): void {
		this.selectedSerchCase.damageNumber = value;

		if (!value || value.length < 2) {
			this.damageNumberSuggestions = [];
			return;
		}

		this.caseService.getDamageNumberSuggestions(value)
			.subscribe(list => this.damageNumberSuggestions = list);
	}

	selectDamageNumber(value: string): void {
		this.selectedSerchCase.damageNumber = value;
		this.damageNumberSuggestions = [];
	}

	clearSearch(): void {
		this.selectedSerchCase = {
			claimant: '',
			defendant: '',
			caseNumber: null,
			damageNumber: null,
			prosecutorsNotice: null,
			dataPTP: null,
			criminalCase: null,
			mvrNumber: null,
			enforcementCase: null,
			traumaType: null,       // dropdown
			traumaTypeName: null,
			traumaText: null,
			uvajeni: false,
			data_suzd_inst_grdelo_ot: null,
			data_suzd_inst_grdelo_do: null,
			responsible: null,
			traumaTypeId: null
		};

		this.claimant = null;

		this.defendant = null;

		this.selectedLawyerId = null;

		this.selectedTraumaTypeId = null;

	}

	@HostListener('document:keydown', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {

		const target = event.target as HTMLElement;

		// ❌ ако пишем в input / textarea → не пречим
		if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')) {
			return;
		}

		// 👉 Ctrl + Enter → Търси
		if (event.ctrlKey && event.key === 'Enter') {
			event.preventDefault();
			this.search();
			return;
		}

		// 👉 Ctrl + Backspace → Clear
		if (event.ctrlKey && event.key === 'Backspace') {
			event.preventDefault();
			this.clearSearch();
			return;
		}

		// 👉 Ctrl + → → Next page
		if (event.ctrlKey && event.key === 'ArrowRight') {
			event.preventDefault();

			if (this.page.number < this.page.totalPages - 1) {
				this.onPageChange(this.page.number + 1, this.page.size);
			}
			return;
		}

		// 👉 Ctrl + ← → Previous page
		if (event.ctrlKey && event.key === 'ArrowLeft') {
			event.preventDefault();

			if (this.page.number > 0) {
				this.onPageChange(this.page.number - 1, this.page.size);
			}
			return;
		}
	}


	resolveCell(row: any, col: any): any {

		if (!row || !col) {
			return '';
		}

		const value = row[col.name];

		if (value === null || value === undefined) {
			return '';
		}

		// complex object (пример: traumaType.name)
		if (
			col.dataType === 'object' &&
			col.complexDataType &&
			col.complexDataType.displayValue &&
			value[col.complexDataType.displayValue] !== undefined
		) {
			return value[col.complexDataType.displayValue];
		}

		// currency
		if (col.dataType === 'currency') {
			return typeof value === 'number'
				? value.toFixed(2)
				: value;
		}

		return value;
	}
	onPageChange(page: number, size: number) {
		// ❌ НЯМА blockUi
		// ❌ НЯМА createSearch

		this.search(page, size, false);
	}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent) {
		const target = event.target as HTMLElement;

		// CASE NUMBER
		if (
			this.caseNumberWrapper &&
			!this.caseNumberWrapper.nativeElement.contains(target)
		) {
			this.caseNumberSuggestions = [];
		}

		// DAMAGE NUMBER
		if (
			this.damageNumberWrapper &&
			!this.damageNumberWrapper.nativeElement.contains(target)
		) {
			this.damageNumberSuggestions = [];
		}
	}

}

